"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import { AdvSearchComponentsWrapper } from "./AdvSearchComponentsWrapper";

export function AdvSearchRow({}) {
  return (
    <Block className={"adv-search-row"} tag={"div"}>
      <FormWrapper className={"adv-search-form-block-container"}>
        <FormForm
          className={"form-2"}
          data-name={"Email Form 3"}
          id={"email-form-3"}
          method={"get"}
          name={"email-form-3"}
        >
          <AdvSearchComponentsWrapper showDesktopFilterButton={false} />
        </FormForm>
        <FormSuccessMessage />
        <FormErrorMessage />
      </FormWrapper>
    </Block>
  );
}
